export type Config = {
  ilEnv: "local" | "development" | "staging" | "production";
  auth: {
    serviceUrl: string;
    redirectUrl: string;
  };
  proofingService: {
    url: string;
  };
  usersAndProjects: {
    url: string;
  };
  pdfTron: {
    licenseKey: string;
    debug?: boolean;
  };
  dataGridPro: {
    licenseKey: string;
  };
  configCat: {
    sdkKey: string;
  };
};

declare global {
  interface Window {
    __CONFIG__: Config;
  }
}

if (!window.__CONFIG__) {
  throw new Error("Runtime config missing. Did /config.js load?");
}

export const config: Config = window.__CONFIG__;

/**
 * Proofing Flow Application ID
 * This UUID identifies the proofing-flow application in the users-and-projects service
 * and is used for filtering projects and permission checks.
 */
export const PROOFING_FLOW_APP_ID = "509db820-55c6-4484-bb95-3ecb3de48327";
